<template>
  <div id="progressFormContent" class="flex layout-column pa-1" style="overflow-y: auto;">
    <div>
      <lx-expansion-panels :single-open="false" v-model="panel">

        <!--   Melder  (panel 0)   -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(0, 'report_header')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-account-edit"
                                     :main-headline="$t('FORMS_DIVERSE.REPORTER_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.REPORTER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="report_header">
              <div class="pa-4 layout-row layout-wrap">
                <melder path="report_header"
                        :isDisabled="isFormDisabled()"
                        :validationRef="validationRef"
                        :isMedicalCommunity="isMedicalCommunity"
                        v-model="model.report_header"
                        :reportReason="model.report_header.meldeanlass"
                        :additionalItemsList="additionalItemsList"
                        form-key="progress"
                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"></melder>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Grunddaten  (panel 1)   -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(1, 'base')">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.BASE_PROGRESS_HEADER') +  ' *'"
                                     icon="mdi-clipboard-pulse"
                                     :sub-headline="$t('FORMS_DIVERSE.BASE_PROGRESS_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="base">
              <div class="pa-4 layout-row layout-wrap">
                <base-data path="base"
                           :key="'BaseDataProgress' + formId"
                           :patientId="patientId"
                           :formId="formId"
                           :isDisabled="isFormDisabled()"
                           v-model="model.base"
                           @set-tnm-defaults="setDefaultsOfTNM"
                           class="layout-row layout-wrap flex-gt-sm-100 flex-100"></base-data>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Leistungszustand   (panel 2)  -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(2, 'allgemeiner_leistungszustand')">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.GENERAL_PERFORMANCE_STATE')"
                                     icon="mdi-arm-flex"
                                     :sub-headline="$t('FORMS_DIVERSE.GENERAL_PERFORMANCE_STATE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="allgemeiner_leistungszustand">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <leistungszustand path="allgemeiner_leistungszustand"
                                  :isDisabled="isFormDisabled()"
                                  v-model="model.allgemeiner_leistungszustand"
                                  class="layout-row flex-gt-sm-100 flex-100"></leistungszustand>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Malignes Melanom bei Diagnose C43* (panel 3) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(3, 'modul_malignes_melanom')"
                            v-show="showModuleInDependencyToICD10('malignes', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-hexagon-multiple"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_malignes_melanom">
              <div class="pa-4 layout-row layout-wrap">
                <malignes-melanom path="modul_malignes_melanom"
                                  :base="model.base"
                                  :tnm="model.tnm"
                                  :validationRef="validationRef"
                                  formKey="progress"
                                  :isDisabled="isFormDisabled()"
                                  v-model="model.modul_malignes_melanom"
                                  class="layout-row layout-wrap flex-gt-sm-100 flex-100"></malignes-melanom>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Prostata bei Diagnosen C61 und D07.5 (panel 4) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(4, 'modul_prostata')"
                            v-show="showModuleInDependencyToICD10('prostata', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_PROSTATA_HEADER')"
                                     icon="mdi-human-male"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_PROSTATA_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_prostata">
              <div class="pa-4 layout-row layout-wrap">
                <modul-prostata path="modul_prostata"
                                :base="model.base"
                                formKey="progress"
                                :patientId="patientId"
                                :validationRef="validationRef"
                                :isDisabled="isFormDisabled()"
                                v-model="model.modul_prostata"
                                class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-prostata>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Mamma bei Diagnosen C50 und D05 (panel 5) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(5, 'modul_mamma')"
                            v-show="showModuleInDependencyToICD10('mamma', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-human-female"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_MAMMA_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_MAMMA_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_mamma">
              <div class="pa-4 layout-row layout-wrap">
                <modul-mamma path="modul_mamma"
                             :base="model.base"
                             formKey="register"
                             :validationRef="validationRef"
                             :isDisabled="isFormDisabled()"
                             v-model="model.modul_mamma"
                             class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-mamma>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Kolo bei Diagnosen C18, C19, C20, D01.0, D01.1, D01.2  (panel 6)-->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(6, 'modul_darm')"
                            v-show="showModuleInDependencyToICD10('kolo', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-emoticon-poop"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_KOLO_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_KOLO_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_darm">
              <div class="pa-4 layout-row layout-wrap">
                <modul-kolo path="modul_darm"
                            :base="model.base"
                            formKey="register"
                            :validationRef="validationRef"
                            :isDisabled="isFormDisabled()"
                            v-model="model.modul_darm"
                            class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-kolo>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Histologie   (panel 7)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(7, 'histologie')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.HISTOLOGY_HEADER')"
                                     icon="mdi-stethoscope"
                                     :sub-headline="$t('FORMS_DIVERSE.HISTOLOGY_SINGLE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="histologie">
              <div class="pa-4 layout-row layout-wrap">
                <histologie path="histologie"
                            :isDisabled="isFormDisabled()"
                            :validationRef="validationRef"
                            v-model="model.histologie"
                            :patientId="patientId"
                            class="layout-row layout-wrap flex-gt-sm-100 flex-100"></histologie>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   TNM    (panel 8) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(8, 'tnm')">
          <lx-expansion-panel-header main-headline="TNM"
                                     icon="mdi-hexagon-multiple-outline"
                                     :sub-headline="$t('FORMS_DIVERSE.TNM_HEADER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="tnm">
              <div class="pa-4 layout-row layout-wrap">
                <tnm path="tnm"
                     :base="model.base"
                     :patientId="patientId"
                     :diagCode="diagCode"
                     :diagDate="diagDate"
                     :formKey="model.key"
                     :isDisabled="isFormDisabled()"
                     v-model="model.tnm"
                     :validationRef="validationRef"
                     class="layout-row layout-wrap flex-gt-sm-100 flex-100"></tnm>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Weitere Klassifikationen  (panel 9)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(9, 'weitere_klassifikation')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_HEADER')"
                                     icon="mdi-vector-polyline"
                                     :sub-headline="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="weitere_klassifikation">
              <weitere-klassifikationen path="weitere_klassifikation"
                                        :isDisabled="isFormDisabled()"
                                        :patientId="patientId"
                                        :validationRef="validationRef"
                                        v-model="model.weitere_klassifikation"
                                        v-bind="{addItem, deleteItem}"
                                        class="layout-wrap flex-gt-sm-100 flex-100"></weitere-klassifikationen>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Fernmetastase   (panel 10)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(10, 'fernmetastase')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.DISTANT_METASTASES_HEADER')"
                                     icon="mdi-chart-bubble"
                                     :sub-headline="$t('FORMS_DIVERSE.DISTANT_METASTASES_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="fernmetastase">
              <fernmetastase path="fernmetastase"
                             :isDisabled="isFormDisabled()"
                             :patientId="patientId"
                             v-model="model.fernmetastase"
                             :isRequired="!!(model && model.base && model.base.verlauf_tumorstatus_fernmetastasen && model.base.verlauf_tumorstatus_fernmetastasen === 'R')"
                             v-bind="{addItem, deleteItem, leadDate}"
                             :validationRef="validationRef"
                             class="layout-wrap flex-gt-sm-100 flex-100"></fernmetastase>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Genetische Varianten   (panel 11)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(11, 'genetische_varianten')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.GENETIC_VARIANT_HEADER')"
                                     icon="mdi-dna"
                                     :sub-headline="$t('FORMS_DIVERSE.GENETIC_VARIANT_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="genetische_varianten">
              <genetische-variante path="genetische_varianten"
                                   :isDisabled="isFormDisabled()"
                                   v-model="model.genetische_varianten"
                                   :validationRef="validationRef"
                                   :patientId="patientId"
                                   :addNewItem="addItem"
                                   :deleteSelectedItem="deleteItem"
                                   class="layout-wrap flex-gt-sm-100 flex-100"></genetische-variante>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Allgemein  (panel 12)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(12, 'modul_allgemein')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_COMMON_HEADER')"
                                     icon="mdi-phone-classic"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_COMMON_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <div class="px-4 pt-4 layout-row layout-wrap">
              <modul-allgemein path="modul_allgemein"
                               :isDisabled="isFormDisabled()"
                               :validationRef="validationRef"
                               v-model="model.modul_allgemein"
                               class="layout-wrap flex-gt-sm-100 flex-100"></modul-allgemein>
            </div>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Anmerkung   (panel 13) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(13, 'anmerkung')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.ANNOTATION_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.ANNOTATION_SUB_LINE')"
                                     icon="mdi-lead-pencil">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="anmerkung">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <anmerkung path="anmerkung"
                           :isDisabled="isFormDisabled()"
                           v-model="model.anmerkung"
                           class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>
      </lx-expansion-panels>
    </div>
  </div>
</template>

<script>
import baseData from '../shared/GrunddatenVerlauf'
import malignesMelanom from '../shared/ModulMalignesMelanom'
import modulProstata from '../shared/ModulProstata'
import modulMamma from '../shared/ModulMamma'
import modulKolo from '../shared/ModulKolo'
import histologie from '../shared/Histologie'
import tnm from '../shared/TNM'
import weitereKlassifikationen from '../shared/WeitereKlassifikation'
import fernmetastase from '../shared/Fernmetastase'
import leistungszustand from '../shared/Leistungszustand'
import modulAllgemein from '../shared/ModulAllgemein'
import anmerkung from '../shared/Anmerkung'
import melder from '../shared/Melder'
import genetischeVariante from '../shared/GenetischeVariante.vue'

import utils from '../../../common/utils'
import lodash from 'lodash'

export default {
  name: 'Progress',
  mixins: [utils],
  components: {
    baseData,
    malignesMelanom,
    modulProstata,
    modulMamma,
    modulKolo,
    histologie,
    tnm,
    weitereKlassifikationen,
    fernmetastase,
    leistungszustand,
    modulAllgemein,
    anmerkung,
    melder,
    genetischeVariante
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    modulesAreEmpty: {
      type: Object,
      default: () => ({})
    },
    // is used to mark headers of invalid modules after trying to complete form (function in utils)
    setIsCompletedIsTriggered: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: String
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    formId: {
      type: String
    }
  },
  data () {
    return {
      model: {
        key: 'progress'
      },
      panel: []
    }
  },
  created () {
    this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)
  },
  methods: {
    /**
     * Set default values of tnm after changing base data
     *
     * @param changedValue {string} The changed value in base data
     */
    setDefaultsOfTNM (changedValue) {
      // if (changedValue === 'gesamtbeurteilung_tumorstatus' && (this.model?.base?.gesamtbeurteilung_tumorstatus === 'V_new' || this.model?.base?.gesamtbeurteilung_tumorstatus === 'V_cont')) {
      //   this.$set(this.model.tnm, 'tnm_c_p_u_praefix_t', 'c')
      //   this.$set(this.model.tnm, 'tnm_t', '0')
      //   this.$set(this.model.tnm, 'tnm_c_p_u_praefix_n', 'c')
      //   this.$set(this.model.tnm, 'tnm_n', '0')
      //   this.$set(this.model.tnm, 'tnm_c_p_u_praefix_m', 'c')
      //   this.$set(this.model.tnm, 'tnm_m', '0')
      //
      //   if (this.model?.base?.untersuchungsdatum_verlauf) {
      //     this.$set(this.model.tnm, 'tnm_datum', this.model.base.untersuchungsdatum_verlauf)
      //   }
      //
      //   // validate tnm manually to ensure that error message appears if necessary
      //   if (this.$refs && this.$refs['tnm']) {
      //     this.$nextTick(() => {
      //       this.$refs['tnm'].validate()
      //     })
      //   }
      //
      //   // open module of tnm, if not already opened
      //   if (this.panel.indexOf(5) < 0) {
      //     this.panel.push(5)
      //   }
      // }

      // set tnm-values per default when form is progress with distance metastasis
      if (changedValue === 'verlauf_tumorstatus_fernmetastasen' && this.model?.base?.verlauf_tumorstatus_fernmetastasen === 'R') {
        this.$set(this.model.tnm, 'tnm_c_p_u_praefix_t', undefined)
        this.$set(this.model.tnm, 'tnm_t', undefined)
        this.$set(this.model.tnm, 'tnm_c_p_u_praefix_n', undefined)
        this.$set(this.model.tnm, 'tnm_n', undefined)
        this.$set(this.model.tnm, 'tnm_c_p_u_praefix_m', 'c')
        this.$set(this.model.tnm, 'tnm_m', '1')

        if (this.model?.base?.untersuchungsdatum_verlauf) {
          this.$set(this.model.tnm, 'tnm_datum', this.model.base.untersuchungsdatum_verlauf)
        }

        // validate tnm manually to ensure that error message appears if necessary
        if (this.$refs && this.$refs['tnm']) {
          this.$nextTick(() => {
            this.$refs['tnm'].validate()
          })
        }

        // open module of tnm, if not already opened
        if (this.panel.indexOf(5) < 0) {
          this.panel.push(5)
        }
      }

      // if (changedValue === 'verlauf_lokaler_tumorstatus' && this.model?.base?.verlauf_lokaler_tumorstatus === 'R' || changedValue === 'verlauf_tumorstatus_lymphknoten' && this.model?.base?.verlauf_tumorstatus_lymphknoten === 'R') {
      //   this.$set(this.model.tnm, 'tnm_r_symbol', 'r')
      //
      //   // set tnm-date, if leadDate from import or date from progress in documentation exists
      //   if (this.model?.base?.untersuchungsdatum_verlauf) {
      //     this.$set(this.model.tnm, 'tnm_datum', this.model.base.untersuchungsdatum_verlauf)
      //   }
      //
      //   // open module of tnm, if not already opened
      //   if (this.panel.indexOf(5) < 0) {
      //     this.panel.push(5)
      //   }
      // }
    }
  },
  computed: {
    // set date of progress as lead date for multiple modules
    leadDate () {
      return this.model.base && this.model.base.untersuchungsdatum_verlauf ? this.model.base.untersuchungsdatum_verlauf : null
    },
    ReportReasonValuesHaveChanged () {
      const state = this.model && this.model.base && this.model.base.gesamtbeurteilung_tumorstatus
      const metastasisState = this.model?.base?.verlauf_tumorstatus_fernmetastasen

      return [state, metastasisState]
    },
    isMedicalCommunity () {
      const user = this.authStore.getters.getAuthUserData && this.authStore.getters.getAuthUserData.user ? this.authStore.getters.getAuthUserData.user : {}
      return user.cancer_form_details && user.cancer_form_details.isMedicalCommunity
    },
    tnmIsRequired () {
      // set tnm as required if state of primary tumor or lymph nodes is "R"
      return this.model && this.model.base && (this.model.base.verlauf_lokaler_tumorstatus === 'R' || this.model.base.verlauf_tumorstatus_lymphknoten === 'R')
    },
    diagDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    diagCode () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagCode : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          // scroll to top, if new form
          if (!this.formId) {
            const myDiv = document.getElementById('progressFormContent')
            if (myDiv) {
              myDiv.scrollTop = 0
            }
          }
        }
      },
      immediate: true
    },
    ReportReasonValuesHaveChanged: {
      handler: function (newValue, oldValue) {
        // set report reason and distance metastasis only after changing value and form is not disabled
        if (!this.isFormDisabled()) {
          this.model.report_header = this.model.report_header || {}
          this.model.report_header.meldeanlass = ''

          // if gesamtbeurteilung_tumorstatus is 'no change' then statusmeldung
          if (newValue[0] && (newValue[0] === 'K' || newValue[0] === 'V_cont')) {
            this.model.report_header.meldeanlass = 'statusmeldung'
            this.$delete(this.model.report_header, 'zertifizierung')
          }

          if (newValue[0] && newValue[0] !== 'K' && newValue[0] !== 'V_cont') {
            this.model.report_header.meldeanlass = 'statusaenderung'
          }

          // if verlauf_tumorstatus_fernmetastasen is 'R' then add metastasis
          if (newValue[1] && newValue[1] === 'R') {
            if (!this.model.fernmetastase || this.model.fernmetastase.length === 0) {
              this.$set(this.model, 'fernmetastase', [{}])
              this.$set(this.model.fernmetastase[0], 'fm_diagnosedatum', this.model.base.untersuchungsdatum_verlauf)
              this.$set(this.model.fernmetastase[0], 'fm_diagnosedatum_genauigkeit', 'E')
            }

            // get index of distance metastases and push to panel, if module is closed
            if (this.modulesAreEmpty?.modules?.fernmetastase) {
              const fernmetastaseIndex = this.modulesAreEmpty.modules.fernmetastase.index

              // open panel of distance metastases, if closed
              if (this.panel.indexOf(fernmetastaseIndex) < 0) {
                this.panel.push(fernmetastaseIndex)
              }
            }
          } else if ((!newValue[1] || newValue[1] && newValue[1] !== 'R') && oldValue && oldValue[1] && newValue[1] !== oldValue[1]) {
            // unset mestatases if verlauf_tumorstatus_fernmetastasen is not R or report reason is not statusaenderung_metastase
            this.$set(this.model, 'fernmetastase', undefined)
          }
        }
      },
      immediate: true
    },
    'modulesAreEmpty.modules': {
      handler: function () {
        this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)

        const self = this
        Object.keys(this.modulesAreEmpty.modules).forEach(key => {
          // push index of filled modules in panel (selected modules are not opened via default)
          if (!self.modulesAreEmpty.modules[key].value && self.panel.indexOf(self.modulesAreEmpty.modules[key].index) < 0) {
            this.$nextTick(() => {
              self.panel.push(self.modulesAreEmpty.modules[key].index)
            })
          }
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

